import React from 'react';
import useLogger from 'hooks/useLogger';
import { NavBarData, StoreIdentifierName } from 'types';
import { checkStores, setDataEmTag } from 'utility/utility';
import setIcon from '../icon-selector';
import './NavBoxes.scss';

type Props = {
  navBarData: NavBarData[] | undefined;
  storeIdentifierName: StoreIdentifierName;
};

export default function NavBoxes({ navBarData = [], storeIdentifierName }: Props) {
  const { error } = useLogger();
  try {
    return (
      <div className="nav-boxes-container hmf-display-flex hmf-justify-content-center hmf-pb-s">
        {navBarData.map((data: NavBarData) => (
          <a
            key={`link-${data.linkTitle}`}
            tabIndex={0}
            href={checkStores(data.link)}
            title={data.linkTitle}
            data-em={setDataEmTag('Header', data.linkTitle)}
            className="nav-boxes-container__box hmf-display-flex hmf-m-xxxs hmf-p-xs hmf-justify-content-flex-start">
            <div className="nav-boxes-container__box--content-container hmf-display-flex hmf-flex hmf-flex-column hmf-align-items-center">
              <div className="nav-boxes-container__box--icon hmf-mb-xxs hmf-display-flex hmf-flex-column hmf-align-items-center hmf-justify-content-center">
                {setIcon(data.mobileIcon ?? '', storeIdentifierName, '')}
              </div>

              <p className="nav-boxes-container__box--link-title hmf-subheader-bold-s">
                {data.linkTitle}
              </p>
            </div>
          </a>
        ))}
      </div>
    );
  } catch (e) {
    error('Could not load TopNavBar - ', e);
    return null;
  }
}
